// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__0gre0","active":"Modal_active__x78mE","modalContent":"Modal_modalContent__PoVZA","closeIcon":"Modal_closeIcon__iRNKP"};